<template>
  <div>
    <modal-layout-top :title="title" />
    <div class="slider-modal" v-if="display">
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">E-post (användarnamn)</label>
            <input class="input" type="text" v-model="user.username" :disabled="user.userId" />
          </div>
          <div class="field" v-if="!isUpdate">
            <label class="label">Lösenord</label>
            <input class="input" type="text" v-model="user.password" />
          </div>
          <div class="field">
            <label class="label">Förnamn</label>
            <input class="input" type="text" v-model="user.firstName" />
          </div>

          <div class="field">
            <label class="label">Efternamn</label>
            <input class="input" type="text" v-model="user.lastName" />
          </div>

          <!-- <div class="field">
            <label class="label">Nickname</label>
            <input class="input" type="text" v-model="user.nickname" />
          </div> -->

          <div class="field">
            <label class="label">Telefon</label>
            <input class="input" type="text" v-model="user.phone" />
          </div>

          <div class="field">
            <label class="label">Alternativ e-post</label>
            <input class="input" type="text" v-model="user.email" />
          </div>
        </div>

        <div class="column">
          <!-- <div class="field">
            <label class="label">Roll</label>
            <div class="select">
              <select v-model="user.role" @change="roleChanged()" :disabled="!hasRole('Staff')">
                <option :value="null" selected>Välj roll...</option>
                <option v-for="role in roles" :key="role.key" :value="role.key">
                  {{ role.value }}
                </option>
              </select>
            </div>
          </div> -->

          <div class="field" v-if="!disablePermissions">
            <label class="label">Behörighet</label>
            <div
              v-for="permission in permissions"
              :key="permission.key"
              class="permission-check"
            >
              <input
                type="checkbox"
                :id="'permission-check-' + permission.key"
                class="switch is-rounded active-switch"
                v-model="user.permissions"
                :value="permission.key"
                :disabled="disablePermissions"
              />
              <label :for="'permission-check-' + permission.key">{{
                permission.value
              }}</label>
            </div>
          </div>

          <!-- <div class="field" v-if="hasPermission('EditUsers')">
            <label class="label">Företag *</label>
            <div class="is-flex">
              <model-list-select
                :isDisabled="!customerSelectEnabled()"
                class="is-inline-input"
                :list="customers"
                option-value="customerId"
                optionText="name"
                v-model="user.customerId"
                placeholder="Välj företag"
              >
              </model-list-select>
              <button
                class="button is-inline-button is-info"
                @click="openCustomerModal()"
                :disabled="!customerSelectEnabled()"
              >
                <i class="fal fa-plus"></i>
              </button>
            </div>
            <div v-show="errors.has('customerId')" class="invalid-feedback">
              {{ errors.first("customerId") }}
            </div>
          </div> -->
        </div>
      </div>
      <modal-layout-buttons :store-name="'users'" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'
import CustomerModal from '@/components/modals/CustomerModal'
import { ModelListSelect } from 'vue-search-select'

export default {
  name: 'user-modal',
  data () {
    return {
      disablePermissions: true,
      user: {
        role: 'Staff',
        permissions: ['EditUsers', 'EditCustomers', 'EditLicenses', 'SystemSettings'],
        customerId: null
      },
      isUpdate: false,
      roles: null,
      permissions: [],
      customers: [],
      display: false,
      editingOwnUser: false,
      previousPermissions: null,
      previousRole: null
    }
  },

  components: {
    ModalLayoutTop,
    ModalLayoutButtons,
    ModelListSelect
  },

  props: {
    id: {
      type: Number,
      required: false
    }
  },

  computed: {
    ...mapState({
      currentUser: (state) => state.auth.user
    }),

    ...mapGetters('auth', ['hasPermission', 'hasRole']),

    title () {
      if (!this.isUpdate) {
        return 'Skapa ny användare'
      } else {
        if (this.currentUser.userId === this.user.userId) {
          return 'Användarprofil'
        }
        return 'Ändra ' + this.user.fullName
      }
    }
  },

  methods: {
    ...mapActions('users', ['update', 'create', 'getById']),
    ...mapActions({
      'getAllCustomers': 'customers/getAll'
    }),

    permissionsOrRoleHasChanged (user) {
      if (this.previousRole !== user.role) {
        console.log('role changed')
        return true
      }

      console.log(this.previousPermissions.length)
      console.log(user.permissions.length)

      if (this.previousPermissions.length !== user.permissions.length) {
        console.log('permissions length changed')
        return true
      }

      for (var i = 0; i < this.previousPermissions.length; i++) {
        if (!user.permissions.includes(this.previousPermissions[i])) {
          console.log('permissions changed')
          return true
        }
      }

      return false
    },

    roleChanged () {
      this.disablePermissions = this.user.role !== 'Staff'
    },

    closePanel () {
      this.$emit('closePanel')
    },

    // customerSelectEnabled () {
    //   return this.user.role === 'Broker'
    // },

    openCustomerModal () {
      this.$panel(CustomerModal, { }).then(response => {
        if (response && response.response) {
          const customer = response.response
          this.customers.push(customer)
          this.user.customerId = customer.customerId
        }
      })
    },

    validate () {
      var ok = true
      if (!this.user.role) {
        this.$toast('Fyll i roll', 'warning')
        ok = false
      }

      if (!this.user.username) {
        this.$toast('Fyll i användarnamn', 'warning')
        ok = false
      }

      if (!this.user.firstName) {
        this.$toast('Fyll i namn', 'warning')
        ok = false
      }

      if (!this.user.lastName) {
        this.$toast('Fyll i efternamn', 'warning')
        ok = false
      }

      if (!this.user.userId && !this.user.password) {
        this.$toast('Fyll i lösenord', 'warning')
        ok = false
      }

      return ok
    },

    save () {
      if (!this.validate()) {
        return
      }

      if (this.user.userId) {

        this.update(this.user)
          .then(data => {
            if (this.editingOwnUser) {
              if (this.permissionsOrRoleHasChanged(data)) {
                this.$alert('Du måste logga ut och logga in igen för att se dina ändringar')
              }
            }
          })
          .catch(() => {
            this.$toast('Felaktig data', 'error')
          })
      }
      else {
        this.create(this.user).then(() => {
          this.closePanel()
        })
      }
    }
  },

  created () {
    this.$on('emitSave', () => {
      this.save()
    })

    var promises = []

    // Get all customers for top dropdown
    promises.push(this.getAllCustomers().then(customers => {
      this.customers = customers
    }))

    promises.push(this.$store.dispatch('meta/getRoles').then((data) => {
      this.roles = data
    }))

    promises.push(this.$store.dispatch('meta/getPermissions').then((data) => {
      this.permissions = data
    }))

    if (!this.id) {
      this.isUpdate = false
      this.disablePermissions = false
    } else {
      promises.push(this.getById(this.id).then((user) => {
        this.user = user
        this.disablePermissions = user.role !== 'Staff'
      }))

      this.editingOwnUser = this.id === this.currentUser.userId

      if (this.editingOwnUser) {
        console.log(this.currentUser.permissions)
        this.previousPermissions = [...this.currentUser.permissions]
        console.log(this.previousPermissions)
        this.previousRole = this.currentUser.role
      }

      this.isUpdate = true
    }
    Promise.all(promises).then(x => {
      this.display = true
    }).catch(error => {
      console.error(error)
      this.$toast('Något gick fel, se konsolen', 'error')
    })
  }
}
</script>

<style scoped lang="scss">
.permission-check {
  margin: 0.25rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/UserModal.vue